import { all, call, fork, takeEvery } from "redux-saga/effects";
import { getMyInfo } from "../../api/mypage/myinfo";
import { getLoginUser } from "../../modules/utils/auth";
import { handleForceLogout } from "../utils/forceLogout";

export const HOME_BAN_CHECK_REQUEST = "home/HOME_BAN_CHECK_REQUEST";

export const homeBanCheckRequest = () => ({ type: HOME_BAN_CHECK_REQUEST });

function* homeBanCheck() {
  // 로그인 상태일 때만 체크
  const user = getLoginUser();
  if (!user) return;

  const response = yield call(getMyInfo);
  if (!response || !response.data) return;
  yield call(handleForceLogout, response);
}

function* watchHomeBanCheckRequest() {
  yield takeEvery(HOME_BAN_CHECK_REQUEST, homeBanCheck);
}

export default function* homeSaga() {
  yield all([fork(watchHomeBanCheckRequest)]);
}
